{
  "version": 1,
  "asset_id": "90125902-cc19-40de-b68d-ae5cbfac563a",
  "project_id": "a02fcdc8-85b3-464c-ad34-cd455060bb51",
  "url": "/__l5e/assets-v1/90125902-cc19-40de-b68d-ae5cbfac563a/ad-video.mp4",
  "r2_key": "a/v1/a02fcdc8-85b3-464c-ad34-cd455060bb51/90125902-cc19-40de-b68d-ae5cbfac563a/ad-video.mp4",
  "original_filename": "ad-video.mp4",
  "size": 901455,
  "content_type": "video/mp4",
  "created_at": "2026-06-17T09:25:25Z"
}
